import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { AuthService } from '../auth/auth.service';
import { ShortSummary, Summary } from './summary.types';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Subject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class WebsocketService {
    private _shortSummarySubject: Subject<ShortSummary> = new Subject();
    private _summarySubject: Subject<Summary> = new Subject();

    private _shortSummaryConnection: WebSocketSubject<any>;
    private _summaryConnection: WebSocketSubject<any> = undefined;

    private _websocketConnnectionAlive: Subject<boolean> = new Subject<boolean>();
    private _currentStationId: string = undefined;
    
    private _isShortSummaryConnectionCloseOnHidden: boolean = false;
    private _isSummaryConnectionCloseOnHidden: boolean = false;

    constructor(private _authService:AuthService) {    
    }

    public onPageHidden() {
        if (this._summaryConnection!==undefined) {
            this.closeSummaryConnection();
            this._isSummaryConnectionCloseOnHidden = true;
        }
        if (this._shortSummaryConnection!==undefined) {
            this.closeShortSummaryConnection();
            this._isShortSummaryConnectionCloseOnHidden = true;
        }
    }

    public onPageVisible() {
        if (this._isShortSummaryConnectionCloseOnHidden) {
            this._isShortSummaryConnectionCloseOnHidden = false;
            this._createShortSummaryConnection();
        }

        if (this._isSummaryConnectionCloseOnHidden) {
            this._isSummaryConnectionCloseOnHidden = false;
            this._createSummaryConnection(this._currentStationId);
        }
    }

    public connectionState(): Subject<boolean> {
        return this._websocketConnnectionAlive;
    }

    public shortSummarySubject(): Subject<ShortSummary> {
        if (!this._shortSummaryConnection) {
            this._createShortSummaryConnection();
        }

        return this._shortSummarySubject;
    }

    public summarySubject(stationId: string): Subject<Summary> {
        if (!this._summaryConnection) {
            this._currentStationId = stationId;
            this._createSummaryConnection(stationId);
        }
        
        return this._summarySubject;
    }

    public closeSummaryConnection() {
        this._summaryConnection.complete();
        this._summaryConnection = undefined;

        this._websocketConnnectionAlive.next(false);
    }

    public closeShortSummaryConnection() {
        this._shortSummaryConnection.complete();
        this._shortSummaryConnection = undefined;

        this._websocketConnnectionAlive.next(false);
    }
    
    private _createShortSummaryConnection() {
        if (this._shortSummaryConnection!=undefined) {
            return this._shortSummaryConnection;
        }

        const openConnection = new Subject();
        const closeConnection = new Subject();
        const shortSummaryConnection = webSocket<any>({url:`${environment.websocketUrl}?stationid=0&user=${this._authService.currentUser.name}`, openObserver:openConnection, closeObserver:closeConnection});
        this._shortSummaryConnection = shortSummaryConnection;

        openConnection.subscribe({
            next: (e) => {
                console.log("short summary connection opened", e);
                this._websocketConnnectionAlive.next(true);
            }
        });

        closeConnection.subscribe({
            next: (e) => {
                console.log("short summary connection closed", e);
            }
        });

        shortSummaryConnection.subscribe({
            error: e => console.error(e),
            next: (shortSummary) => {
                this._shortSummarySubject.next(shortSummary);
            },
            complete: () => {
                console.log("Short Summary Connection completed");
            }
        });
    }

    private _createSummaryConnection(stationId:string) {
        if (this._summaryConnection!=undefined) {
            console.log("please close previous summary connection before call a new one");
            return;
        }

        const openConnection = new Subject();
        const closeConnection = new Subject();
        const summaryConnection = webSocket<any>({url:`${environment.websocketUrl}?stationid=${stationId}&user=${this._authService.currentUser.name}`, openObserver:openConnection, closeObserver:closeConnection});
        this._summaryConnection = summaryConnection;

        openConnection.subscribe({
            next: (e) => {
                console.log(`summary connection for station-id:${stationId} opened`, e);
                this._websocketConnnectionAlive.next(true);
            }
        });

        closeConnection.subscribe({
            next: (e) => {
                console.log(`summary connection for station-id:${stationId} closed`, e);
            }
        });
        
        summaryConnection.subscribe({
            error: e => console.error(e),
            next: (summary) => {
                this._summarySubject.next(summary);
            },
            complete: () => {
                console.log("Summary Connection completed");
            }
        });
    }
}

